import { PaymentStatus } from '@wix/wix-vod-constants/api-types';
import { PublicPurchaseService } from './purchase';
import { buildUrl, openBlankTab, URL_PARAM_COMP_ID, URL_PARAM_PAYMENT_TYPE, URL_PARAM_STATE, URL_PARAM_VIDEO_ID, URL_STATE_COMPLETE_PURCHASE, getBsi, } from '@wix/wix-vod-shared/common';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
const APIUrls = {
    order: '/cashier/order',
    status: (order, transaction) => `/cashier/order/${order}/transaction/${transaction}/status`,
};
const BASE_URL = `${PRODUCTION_HOSTS.paypal}/vod`;
const statusesMap = {
    SUCCESS: PaymentStatus.ACTIVE,
    APPROVED: PaymentStatus.ACTIVE,
    OK: PaymentStatus.ACTIVE,
    PENDING: PaymentStatus.PENDING,
    PENDING_MERCHANT: PaymentStatus.PENDING,
    CANCEL: PaymentStatus.CANCELED,
    CANCELED: PaymentStatus.CANCELED,
};
export class PublicPurchaseServiceV2 extends PublicPurchaseService {
    constructor(httpClient) {
        super();
        this.httpClient = httpClient;
    }
    async createOrder(videoId, channelId, paymentType, siteUrl, instance, compId) {
        const { data } = await this.httpClient.post(`${BASE_URL}${APIUrls.order}`, {
            channelId,
            refItemId: videoId,
            type: paymentType,
            ref: siteUrl,
            redirectParams: {
                returnUrl: siteUrl,
                [URL_PARAM_COMP_ID]: compId,
                [URL_PARAM_VIDEO_ID]: videoId,
                [URL_PARAM_PAYMENT_TYPE]: paymentType,
                [URL_PARAM_STATE]: URL_STATE_COMPLETE_PURCHASE,
            },
        }, {
            params: { instance, bsi: getBsi() },
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            // @ts-expect-error we have to set null to override it, otherwise we get cors issues, normally we should fix the issue itself instead
            xsrfCookieName: null,
            // @ts-expect-error we have to set null to override it, otherwise we get cors issues
            xsrfHeaderName: null,
        });
        return data.order.id;
    }
    async getPaymentStatus(videoId, channelId, orderId, transactionId, instance, paymentType) {
        const { status } = await this.httpClient
            .get(`${BASE_URL}${APIUrls.status(orderId, transactionId)}`, {
            params: { instance, bsi: getBsi() },
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            // @ts-expect-error we have to set null to override it, otherwise we get cors issues
            xsrfCookieName: null,
            // @ts-expect-error we have to set null to override it, otherwise we get cors issues
            xsrfHeaderName: null,
        })
            .then((response) => ({ status: response.data.status }), (error) => ({ status: 'ERROR', error }));
        return statusesMap[status];
    }
    async cancelOrder(channelId, siteUrl, instance) {
        openBlankTab(buildUrl(`${PRODUCTION_HOSTS.paypal}/vod/pp/subscribe/cancel_profile`, {
            type: 'subscription',
            channelId,
            ref: siteUrl,
            instance,
        }));
    }
}
//# sourceMappingURL=purchase.v2.js.map